import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Agent, BankDetails, Organization, OrganizationClient, OrganizationToken, OrganizationTokenClient, ServiceProvider } from "src/app/web-api-client";
import { OrganizationalTypes } from "../../../../enums/organizational-types.enum";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {Subject } from "rxjs";

@Component({
  selector: 'app-org-token-creation',
  templateUrl: './org-token-creation.component.html',
  styleUrls: ['./org-token-creation.component.scss']
})
export class OrgTokenCreationComponent implements OnInit {

  public isChildSelected: boolean = false;
  public onClose = new Subject<boolean>();

  public orgId: number;
  public isLoaded = true;
  public organizations: OrganizationToken[];

  Form: FormGroup;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, public orgClient: OrganizationTokenClient) { }

  ngOnInit(): void {

    this.isLoaded = false;
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: ['', Validators.required]
    });
  }
 


  onSubmit() {
    if (this.Form.valid) {

      let newUser = new OrganizationToken();

      newUser.id = 0;
      newUser.title = this.Form.value.title;
      newUser.organizationId = this.orgId;

      this.orgClient.create(newUser).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  } 
}
